module.exports = __webpack_public_path__ + "img/bg.6875ea0d.png";